const dayjs = useDayjs()

export function getEmloyeeType(type: number) {
    const { t } = useI18n()
    switch (type) {
        case 1:
            return t('user.owner')
        case 2:
            return t('user.moderator')
        case 3:
            return t('user.employee')
        default:
            return t('general.unknown')
    }
}

export function getUserStatus(status: number) {
    const { t } = useI18n()
    switch (status) {
        case 1:
            return t('general.active')
        case 0:
            return t('general.inactive')
        default:
            return t('general.unknown')
    }
}

export function timeToString(time: number) {
    let hours = Math.floor(time / 60).toString().padStart(2, '0')
    let minutes = Math.floor(time % 60).toString().padStart(2, '0')
    return `${hours}:${minutes}`
}

export function getDay() {
  let now = new Date()
  let day = now.getFullYear() * 10000 + (now.getMonth() + 1) * 100 + now.getDate()
  return day
}

export function dayIdToLocaleString(day_id: number | undefined) {
    if (!day_id) return ''
    
    let day_id_str = day_id.toString()
    let year = parseInt(day_id_str.substring(0, 4))
    let month = parseInt(day_id_str.substring(4, 6)) - 1
    let day = parseInt(day_id_str.substring(6, 8))

    let as_string = dayjs().year(year).month(month).date(day).format('D MMM, dddd')
    return as_string
}

export function dayIdToShortLocaleString(day_id: number | undefined) {
    if (!day_id) return ''
    
    let day_id_str = day_id.toString()
    let year = parseInt(day_id_str.substring(0, 4))
    let month = parseInt(day_id_str.substring(4, 6)) - 1
    let day = parseInt(day_id_str.substring(6, 8))

    let as_string = dayjs().year(year).month(month).date(day).format('D MMM, ddd')
    return as_string
}

export function dayIdToDate(day_id: number): Date {
    let day_id_str = day_id.toString()
    let year = parseInt(day_id_str.substring(0, 4))
    let month = parseInt(day_id_str.substring(4, 6)) - 1
    let day = parseInt(day_id_str.substring(6, 8))
    
    return new Date(year, month, day)
}

export function dayIdToString(day_id: number) {
    let day_id_str = day_id.toString()
    let year = parseInt(day_id_str.substring(0, 4))
    let month = parseInt(day_id_str.substring(4, 6))
    let day = parseInt(day_id_str.substring(6, 8))
    return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`
}

export function unixToLocaleString(unix: number) {
    return dayjs.unix(unix).format('D MMM, dddd')
}
